function mediaQueriesWin(){
      $(".has-child>a").off('click');
      $(".has-child>a").on('click', function() {
        var parentElem =  $(this).parent();
        $('.has-child').not(parentElem).children('ul').slideUp(250);
        $(parentElem).toggleClass('active');
        $(parentElem).children('ul').stop().slideToggle(250);
        $(document).on('click',function(e) {
          if(!$(e.target).closest($(parentElem)).length) {
            $('.has-child').children('ul').slideUp(250);
          }
        });
        return false;
      });

  }

  $(window).on('load',function(){
    mediaQueriesWin();
  });